/* Ofertas Flash TCL — countdown, entrance animations and coupon copy.
   Each section renders a <tcl-flash-deals> element with its config in a
   <script type="application/json" data-tf-config> child. */
(function () {
  if (customElements.get('tcl-flash-deals')) return;

  var DAY = 86400000;

  function pad(n) {
    return n < 10 ? '0' + n : String(n);
  }

  // "-0300" / "-03:00" -> -180
  function parseOffset(tz) {
    var m = /^([+-])(\d{2}):?(\d{2})$/.exec(tz || '');
    if (!m) return -new Date().getTimezoneOffset();
    var mins = parseInt(m[2], 10) * 60 + parseInt(m[3], 10);
    return m[1] === '-' ? -mins : mins;
  }

  function parseClock(value, fallback) {
    var m = /^(\d{1,2}):(\d{2})$/.exec((value || '').trim());
    if (!m || +m[1] > 23 || +m[2] > 59) return fallback;
    return [+m[1], +m[2]];
  }

  // Epoch ms for a store-local date ("YYYY-MM-DD") and clock, or NaN.
  function storeTime(date, clock, offset) {
    var d = /^(\d{4})-(\d{2})-(\d{2})$/.exec((date || '').trim());
    if (!d) return NaN;
    return Date.UTC(+d[1], +d[2] - 1, +d[3], clock[0], clock[1], 0) - offset * 60000;
  }

  class TclFlashDeals extends HTMLElement {
    connectedCallback() {
      var node = this.querySelector('[data-tf-config]');
      if (!node) return;
      try {
        this.cfg = JSON.parse(node.textContent);
      } catch (e) {
        return;
      }
      this.offset = parseOffset(this.cfg.tz);
      this.designMode = !!(window.Shopify && window.Shopify.designMode);
      this.countdown = this.querySelector('[data-tf-countdown]');
      this.expiredMsg = this.querySelector('[data-tf-expired]');
      this.editorNote = this.querySelector('[data-tf-editor-note]');
      this.section = this.closest('.shopify-section') || this;

      this.classList.add('tf-js');
      this.setupReveal();
      this.setupCoupons();

      // Countdown off: the section is a plain "featured deals" showcase,
      // always visible, with no schedule to enforce.
      if (this.cfg.countdown === false) {
        this.section.style.display = '';
        return;
      }

      this.tick = this.tick.bind(this);
      this.tick();
      this.timer = setInterval(this.tick, 1000);
    }

    disconnectedCallback() {
      clearInterval(this.timer);
      if (this.observer) this.observer.disconnect();
    }

    // Returns { state: 'running' | 'expired' | 'pending', remaining: ms }
    status(now) {
      var cfg = this.cfg;
      var off = this.offset;

      if (cfg.mode === 'fixed') {
        var end = storeTime(cfg.endDate, parseClock(cfg.endTime, [23, 59]), off);
        if (isNaN(end)) return { state: 'invalid', remaining: 0 };
        var start = storeTime(cfg.startDate, parseClock(cfg.startTime, [0, 0]), off);
        if (!isNaN(start) && now < start) return { state: 'pending', remaining: 0 };
        return end > now ? { state: 'running', remaining: end - now } : { state: 'expired', remaining: 0 };
      }

      if (cfg.mode === 'evergreen') {
        var key = 'tclFlash:' + cfg.id;
        var duration = Math.max(1, cfg.duration || 24) * 3600000;
        var deadline = NaN;
        try {
          deadline = parseInt(localStorage.getItem(key), 10);
        } catch (e) {}
        if (isNaN(deadline) || (deadline <= now && cfg.restart)) {
          deadline = now + duration;
          try {
            localStorage.setItem(key, String(deadline));
          } catch (e) {}
        }
        return deadline > now ? { state: 'running', remaining: deadline - now } : { state: 'expired', remaining: 0 };
      }

      // Daily: counts down to the configured clock time, every active weekday.
      var local = new Date(now + off * 60000);
      var weekday = local.getUTCDay() || 7;
      if (cfg.days && cfg.days.indexOf(weekday) === -1) return { state: 'expired', remaining: 0 };
      var clock = parseClock(cfg.dailyEnd, [23, 59]);
      var target =
        Date.UTC(local.getUTCFullYear(), local.getUTCMonth(), local.getUTCDate(), clock[0], clock[1], 0) - off * 60000;
      if (target <= now) target += DAY;
      return { state: 'running', remaining: target - now };
    }

    tick() {
      var st = this.status(Date.now());
      var running = st.state === 'running';
      var showZero = !running && this.cfg.onExpire === 'zero';

      if (running || showZero) this.render(st.remaining);

      if (this.countdown) this.countdown.hidden = !(running || showZero);
      if (this.expiredMsg) this.expiredMsg.hidden = running || this.cfg.onExpire !== 'message' || st.state !== 'expired';

      var hide = !running && (st.state === 'pending' || st.state === 'invalid' || this.cfg.onExpire === 'hide');
      if (this.designMode) {
        // Never hide the section while editing; explain why it would be.
        if (this.editorNote) {
          var msg = this.cfg.notes[st.state];
          this.editorNote.hidden = !(msg && (hide || st.state === 'invalid'));
          if (msg) this.editorNote.textContent = msg;
        }
      } else {
        this.section.style.display = hide ? 'none' : '';
      }

      if (st.state !== 'running' && st.state !== 'pending' && this.cfg.mode === 'fixed' && !this.designMode) {
        clearInterval(this.timer);
      }
    }

    render(ms) {
      var total = Math.floor(ms / 1000);
      var days = Math.floor(total / 86400);
      var showDays = this.cfg.showDays === 'always' || (this.cfg.showDays === 'auto' && days > 0);
      var hours = showDays ? Math.floor((total % 86400) / 3600) : Math.floor(total / 3600);
      var values = {
        d: days,
        h: hours,
        m: Math.floor((total % 3600) / 60),
        s: total % 60,
      };

      var dayGroup = this.querySelector('[data-tf-group="d"]');
      if (dayGroup) dayGroup.hidden = !showDays;

      var units = this.querySelectorAll('[data-tf-unit]');
      for (var i = 0; i < units.length; i++) {
        this.setDigits(units[i].querySelector('[data-tf-digits]'), pad(values[units[i].getAttribute('data-tf-unit')]));
      }

      if (this.countdown) {
        var urgent = this.cfg.urgency > 0 && ms > 0 && ms <= this.cfg.urgency * 60000;
        this.countdown.classList.toggle('is-urgent', urgent);
      }
    }

    setDigits(container, text) {
      if (!container) return;
      var spans = container.children;
      if (spans.length !== text.length) {
        container.textContent = '';
        for (var j = 0; j < text.length; j++) {
          var span = document.createElement('span');
          span.className = 'tf-digit';
          span.textContent = text[j];
          container.appendChild(span);
        }
        return;
      }
      for (var i = 0; i < text.length; i++) {
        if (spans[i].textContent === text[i]) continue;
        spans[i].textContent = text[i];
        spans[i].classList.remove('is-ticking');
        void spans[i].offsetWidth; // restart the animation
        spans[i].classList.add('is-ticking');
      }
    }

    setupReveal() {
      var items = this.querySelectorAll('[data-tf-reveal]');
      if (!('IntersectionObserver' in window) || this.getAttribute('data-entrance') === 'none') {
        for (var i = 0; i < items.length; i++) items[i].classList.add('is-visible');
        return;
      }
      this.observer = new IntersectionObserver(
        function (entries, observer) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          });
        },
        { threshold: 0.15 }
      );
      for (var k = 0; k < items.length; k++) this.observer.observe(items[k]);
    }

    setupCoupons() {
      var buttons = this.querySelectorAll('[data-tf-copy]');
      for (var i = 0; i < buttons.length; i++) {
        buttons[i].addEventListener('click', function (event) {
          var btn = event.currentTarget;
          var label = btn.querySelector('[data-tf-coupon-label]');
          var code = btn.getAttribute('data-tf-copy');
          var done = function () {
            if (!label) return;
            if (!btn.dataset.original) btn.dataset.original = label.innerHTML;
            label.textContent = btn.getAttribute('data-tf-copied');
            clearTimeout(btn._tfTimer);
            btn._tfTimer = setTimeout(function () {
              label.innerHTML = btn.dataset.original;
            }, 2200);
          };
          if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(code).then(done, done);
          } else {
            var input = document.createElement('textarea');
            input.value = code;
            input.setAttribute('readonly', '');
            input.style.position = 'absolute';
            input.style.left = '-9999px';
            document.body.appendChild(input);
            input.select();
            try {
              document.execCommand('copy');
            } catch (e) {}
            document.body.removeChild(input);
            done();
          }
        });
      }
    }
  }

  customElements.define('tcl-flash-deals', TclFlashDeals);
})();
